import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const active = params.get("collection") || "all";
  const [products, setProducts] = useState([]);
  const [collections, setCollections] = useState([]);

  useEffect(() => { api.get("/collections").then((r) => setCollections(r.data.filter((c) => c.key !== "digital"))); }, []);
  useEffect(() => {
    const p = active === "all" ? {} : { collection_key: active };
    api.get("/products", { params: p }).then((r) => setProducts(r.data.filter((x) => x.product_type === "box")));
  }, [active]);

  const setCol = (key) => { if (key === "all") setParams({}); else setParams({ collection: key }); };

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20">
      <div className="max-w-2xl">
        <span className="gh-overline">The Shop</span>
        <h1 className="font-heading text-5xl sm:text-6xl text-[#3A3632] mt-4">Gifts that hold space.</h1>
        <div className="gh-hairline my-7 max-w-[120px]" />
        <p className="text-lg text-[#6B655F] leading-relaxed font-light">Browse our curated boxes, each assembled by hand and finished with a handwritten Hope Card.</p>
        <Link to="/kit-finder" data-testid="shop-quiz-link"
          className="inline-flex items-center gap-2 mt-6 bg-[#8E9A86]/10 border border-[#8E9A86]/30 text-[#7A8772] rounded-full px-5 py-2.5 text-sm font-medium hover:bg-[#8E9A86]/15 transition-colors">
          <span aria-hidden>✨</span> Not sure which kit to choose? Take our 60-second Kit Finder Quiz →
        </Link>
      </div>

      <div className="flex flex-wrap gap-x-7 gap-y-3 mt-12 mb-12">
        <button onClick={() => setCol("all")} data-testid="filter-all"
          className={`text-[13px] tracking-[0.12em] uppercase pb-1.5 border-b transition-colors duration-300 ${active === "all" ? "text-[#8E9A86] border-[#D9CBA0]" : "text-[#3A3632] border-transparent hover:border-[#D9CBA0]"}`}>All Boxes</button>
        {collections.map((c) => (
          <button key={c.key} onClick={() => setCol(c.key)} data-testid={`filter-${c.key}`}
            className={`text-[13px] tracking-[0.12em] uppercase pb-1.5 border-b transition-colors duration-300 ${active === c.key ? "text-[#8E9A86] border-[#D9CBA0]" : "text-[#3A3632] border-transparent hover:border-[#D9CBA0]"}`}>{c.name}</button>
        ))}
      </div>

      {products.length === 0 ? (
        <p className="text-[#8A8175] py-20 text-center">No boxes in this collection yet — check back soon.</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="shop-grid">
          {products.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
